<template>

  <select-org
    :label="label"
    type="Tower Supplier"
    v-model="formData"
    :required="required"
    :placeholder="placeholder"
    :help-text="helpText"
    :no-form="noForm"
    value-key="value"
    :size="size"
    :full-object="true"
    :disabled="disabled"
    @change="updated"
    />

</template>

<script>

import SelectOrg from '@/components/atoms/selects/SelectOrg'

export default {
  name: 'select-tower-supplier',

  components: {
    SelectOrg
  },

  props: {
    label: {
      type: String,
      default: 'Tower Supplier'
    },
    value: {
//      type: String,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    required: {
      type: Boolean,
      default: false
    },
    size: {
      type: String,
      default: 'default'
    },
    placeholder: {
      type: String,
      default: null
    },
    helpText: {
      type: String,
      default: null
    },
    fullObject: {
      type: Boolean,
      default: true
    },
    noForm: {
      type: Boolean,
      default: false
    }
  },

  methods: {
    // The inner select always answers with the organisation (full-object); this wrapper hands back what its caller holds: the id
    // (`full-object` false: SiteForm's and StructDetails' `supplier_id`) or the organisation (the RTA option's `supplier`).
    updated (val) {

      if (!this.fullObject) {
        this.$emit('input', val ? val.value : null, val)
        this.$emit('change', val ? val.value : null, val)
      } else {
        this.$emit('input', val)
        this.$emit('change', val)
      }
    }
  },

  // XOL-67: follow the parent's value (read once in data(), a supplier loaded after mount was never shown).
  watch: {
    value: function (v) {
      this.formData = v
    }
  },

  data () {
    return {
      formData: this.value
    }
  }
}
</script>
